import { isEmpty } from 'lodash';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import hexToRGBA from '../../../util/HEXToRGBA';
import IconButton from '@mui/material/IconButton';
import Typography from '@material-ui/core/Typography';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import { useDispatch, useSelector } from 'react-redux';
import PageLoader from '../../../components/PageLoader';
import { getSesssionData } from '../../../util/Functions';
import globalColors from '../../../theme/GlobalColorsv2.js';
import FocusedWindows from '../../../components/FocusedWindows';
import { fetchUDW } from '../../../redux/reducers/UDW/UdwWindows';
import { SPLIT_SCREEN } from '../../../constants/WorkQueueConstants';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ErrorSnackbar, SuccessSnackbar } from '../../../components/CustomSnackBar';
import FavoriteWindowToggler from '../../../components/FavoriteWindowToggler/index.js';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import FormUpdatedContext from '../../../contexts/FormUpdatedContext.js';
import { ReactComponent as DoubleArrowRightIcon } from '../../../assets/images/keyboardDoubleArrowRightIcon.svg';

import {
  clearWindowError,
  deleteModifiedWindowSessionItem,
  removeModifiedWindow,
} from '../../../redux/reducers/ModifiedWindows';
import {
  // PATIENT_DEMOGRAPHICS,
  PATIENT_CUSTOMER_INFORMATION,
  SPOUSE_INFORMATION,
  POE_INFORMATION,
  COMMUNICATION_OPT_OUTS,
} from '../../../util/Content';

const CustomChipWrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export default function CustomTabsNew({ selected, setSelected, age, setAge }) {
  let activeWindow = null;
  try {
    activeWindow = JSON.parse(sessionStorage.getItem('activeWindow'));
  } catch (err) {
    sessionStorage.setItem('activeWindow', {});
  }

  const [value, setValue] = useState(activeWindow?.index ? Number(activeWindow?.index) : 0);
  const { showDashboardWorkQueue } = useSelector(({ role }) => role);
  const [tempReRenderWindow, setTempReRenderWindow] = useState(true);
  const { windowsErrorList } = useSelector(({ modifiedWindows }) => modifiedWindows);
  const { isLoading, errorMsg, successMsg } = useSelector(({ saveAllWindows }) => saveAllWindows);
  const { accountSummaryData } = useSelector(({ accountSummary }) => accountSummary);
  const {
    label,
    setLabel,
    setSummary,
    windowsData,
    hideSummary,
    selectedTabs,
    setOnChipClick,
    defaultWindows,
    focusedWindows,
    previousFavTabs,
    setCurrentLabel,
    setSelectedTabs,
    setFocusedWindows,
    currentSelectedTab,
    setCurrentSelectedTab,
  } = useContext(SelectTabContextProvider);
  const defaultTabs = [...defaultWindows];
  const [activeTabs] = useState([]);
  const [chipData, setChipData] = useState([]);
  const dispatch = useDispatch();
  const { favouriteWindowsData } = useSelector(({ favouriteWindows }) => favouriteWindows);
  const [setOpen] = useState(false);
  const [visibleChips, setVisibleChips] = useState(selectedTabs.length);
  const selectTabTempdata = useRef({});
  const { udwData } = useSelector(({ udwWindows }) => udwWindows);
  const { roleData } = useSelector(({ role }) => role);
  const handleChange = (event, newValue) => {};

  /**
   * @type {FormUpdatedContextType}
   */
  const { updatedForms } = useContext(FormUpdatedContext);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const modifiedWindows = getSesssionData('modifiedWindowsFields');
      if (!modifiedWindows && !isEmpty(modifiedWindows)) {
      } else {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchUDW());
  }, []);

  const getTab = (code) => {
    for (const i in windowsData) {
      if (windowsData[i].code === code) {
        return { label: windowsData[i].label, code: code };
      }
    }
  };

  const getLabelFav = (label) => {
    const sliced = label;
    for (let i = 0; i < udwData.length; i++) {
      if (udwData[i].windowName == sliced) {
        const windowLabel = `${udwData[i].windowDescription}`;
        return windowLabel;
      }
    }
  };

  const filterPrevTabs = previousFavTabs?.filter(
    (item) => !favouriteWindowsData?.windowName?.includes(item),
  );

  const getPrevTabs = () => label?.filter((item) => !filterPrevTabs?.includes(item));
  const shouldEffectRun = sessionStorage.getItem('shouldEffectRun');
  useEffect(() => {
    if (
      favouriteWindowsData?.windowName?.length > 0 &&
      !(
        favouriteWindowsData?.windowName?.length === 1 && favouriteWindowsData?.windowName[0] === ''
      ) &&
      !shouldEffectRun
    ) {
      if (udwData?.length > 0) {
        sessionStorage.setItem('shouldEffectRun', true);
      }
      const newTab =
        windowsData?.length > 0 && roleData?.window && roleData?.window?.['Core Windows']
          ? windowsData?.filter((item) =>
            Object.keys(roleData?.window?.['Core Windows'])?.includes(item?.code),
          )
          : [];
      const newWindowCodes = newTab?.length > 0 ? newTab?.map((item) => item?.code) : [];
      const validWindows = [];
      favouriteWindowsData?.windowName &&
        favouriteWindowsData?.windowName?.forEach((item) => {
          if (newWindowCodes?.includes(item)) {
            validWindows.push(item);
          }
        });
      const favourites1 = [];
      favouriteWindowsData?.windowName?.forEach((item) => {
        if (newWindowCodes?.includes(item)) {
          favourites1.push(getTab(item));
        }
      });
      const filtered = favourites1?.map((i) => i?.code);
      const customs = roleData?.window?.['Custom Window']
        ? Object.keys(roleData.window['Custom Window'])
        : '';
      const result = favouriteWindowsData?.windowName?.filter(
        (data, idx) => !filtered.includes(data) && customs?.includes(data),
      );
      result?.forEach((item) => {
        const details = getLabelFav(item);
        const slicedItem = item;
        if (details) {
          favourites1.push({ label: details, code: slicedItem, windowType: 'Custom Windows' });
        }
      });
      const label1 = label?.filter(
        (item) =>
          !favouriteWindowsData?.windowName.includes(item) &&
          !previousFavTabs?.includes(item) &&
          newWindowCodes?.includes(item),
      );
      const selected1 =
        selectedTabs &&
        selectedTabs?.filter(
          (item) =>
            !favouriteWindowsData?.windowName?.includes(item.code) &&
            newWindowCodes?.includes(item.code) &&
            !previousFavTabs?.includes(item.code),
        );
      (favouriteWindowsData?.windowName || label1) && setLabel([...label1, ...validWindows]);
      (selected1 || favourites1) && setSelectedTabs([...selected1, ...favourites1]);
    } else if (favouriteWindowsData?.windowName?.length === 0) {
      const selected =
        selectedTabs && selectedTabs?.filter((item) => !filterPrevTabs?.includes(item.code));
      selected && setSelectedTabs([...selected]);
      selected && setLabel([...getPrevTabs()]);
    }
  }, [favouriteWindowsData]);

  const age18 = 18;
  const calculateAge = (dob1) => {
    const today = new Date();
    const birthDate = new Date(dob1);
    let ageNow = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      ageNow--;
    }
    return ageNow > 0 ? ageNow : null;
  };

  useEffect(() => {
    if (selectedTabs.length > 0) {
      const data = [...defaultTabs, ...selectedTabs];
      const uniqData = [
        ...new Map(data.filter(Boolean).map((item) => [item['code'], item])).values(),
      ];
      const availableWindows = uniqData.map((item) => item?.code);
      if (Object.keys(roleData).length > 0) {
        if (
          Object.keys(roleData?.window).includes('Core Windows') &&
          Object.keys(roleData?.window).includes('Custom Window')
        ) {
          setChipData(uniqData);
        } else if (Object.keys(roleData?.window).includes('Custom Window')) {
          const customResponse = uniqData?.filter((data) => {
            if (typeof data.code === 'number') {
              const parsed = data?.code?.toString();
              return !parsed.includes('W');
            } else {
              return !data?.code?.includes('W');
            }
          });

          setChipData(customResponse);
        } else if (Object.keys(roleData?.window).includes('Core Windows')) {
          const rest = uniqData?.filter((data) => {
            return data?.code?.includes('W');
          });

          const forStatus =
            uniqData?.length > 0 ? uniqData?.filter((data) => data?.code?.includes('ST')) : [];

          setChipData([
            {
              code: '10',
              hideDeleteIcon: true,
              label: 'Important Notes',
            },
            {
              code: 'Account Status',
              hideDeleteIcon: true,
              label: 'Account Status',
            },
            {
              code: '0',
              hideDeleteIcon: true,
              label: 'Account Summary',
            },
            ...rest,
            ...forStatus,
          ]);
        }
      }
      if (uniqData && uniqData.length) {
        availableWindows.indexOf(uniqData[uniqData.length - 1]?.code) === -1
          ? setLabel([...label, uniqData[uniqData.length - 1]?.code])
          : setLabel([...availableWindows]);
      }
    } else if (selectedTabs.length === 0) {
      setCurrentLabel('');
      setOnChipClick(false);
      setChipData([
        { label: 'Important Notes', code: '10', hideDeleteIcon: true },
        { label: 'Account Status', code: 'Account Status', hideDeleteIcon: true },
        { label: 'Account Summary', code: '0', hideDeleteIcon: true },
      ]);
      setLabel(['10', 'Account Status', '0']);
    }

    /* const chipBarWrapper = document.querySelector('.chip-wrapper');
    if (chipBarWrapper.clientWidth > 1266) {
      setPopoverOpen(false);
      setVisibleChips((visibleChips) => {
        return visibleChips - 1;
      });
    } else {
      setPopoverOpen(false);
      setVisibleChips(4);
    }
    */
  }, [selectedTabs, roleData]);

  const handleFocusedWindowToggle = (selectedWindow) => {
    setFocusedWindows((currentWindows) => {
      const exists = currentWindows.some((window) => window.code === selectedWindow.code);
      if (exists) {
        return currentWindows.filter((window) => window.code !== selectedWindow.code);
      }

      return [...currentWindows, selectedWindow];
    });
  };

  const handleFocusedWindowRemoval = (code) => {
    setFocusedWindows((currentWindows) => {
      const exists = currentWindows.some((window) => window.code === code);
      if (exists) {
        return currentWindows.filter((window) => window.code !== code);
      }

      return [...currentWindows];
    });
  };

  const handleTabSelect = (each, index) => {
    if (!(windowsErrorList && windowsErrorList[currentSelectedTab?.label]?.hasError)) {
      setTempReRenderWindow(false);
      setTimeout(() => {
        setTempReRenderWindow(true);
      }, 1);
    }

    handleFocusedWindowToggle(each);

    const obj = getSesssionData('modifiedWindowsFields');
    if (
      windowsErrorList &&
      windowsErrorList[currentSelectedTab?.label]?.hasError &&
      obj[currentSelectedTab?.label]
    ) {
      setOpen(true);
      selectTabTempdata.current = { tab: currentSelectedTab, currT: each, index };
    } else if (
      windowsErrorList &&
      windowsErrorList[PATIENT_CUSTOMER_INFORMATION]?.hasError &&
      obj[PATIENT_CUSTOMER_INFORMATION]
    ) {
      setOpen(true);
      selectTabTempdata.current = { tab: currentSelectedTab, currT: each, index };
    } else if (
      windowsErrorList &&
      windowsErrorList[SPOUSE_INFORMATION]?.hasError &&
      obj[SPOUSE_INFORMATION]
    ) {
      setOpen(true);
      selectTabTempdata.current = { tab: currentSelectedTab, currT: each, index };
    } else if (
      windowsErrorList &&
      windowsErrorList[POE_INFORMATION]?.hasError &&
      obj[POE_INFORMATION]
    ) {
      setOpen(true);
      selectTabTempdata.current = { tab: currentSelectedTab, currT: each, index };
    } else if (
      windowsErrorList &&
      windowsErrorList[COMMUNICATION_OPT_OUTS]?.hasError &&
      obj[COMMUNICATION_OPT_OUTS]
    ) {
      setOpen(true);
      selectTabTempdata.current = { tab: currentSelectedTab, currT: each, index };
    } else if (each?.code !== currentSelectedTab?.code) {
      setCurrentSelectedTab(each);
      setValue(index);
      setSummary(false);
    }
    setPopoverOpen(false);
  };

  const handleRemove = ({ label, code }, indexRemoved) => {
    const filteredWindows = chipData.filter((chip) => chip.code !== code);
    if (label === 'Patient / Customer Demographics') {
      deleteModifiedWindowSessionItem(PATIENT_CUSTOMER_INFORMATION);
      dispatch(clearWindowError({ windowName: PATIENT_CUSTOMER_INFORMATION }));
      dispatch(removeModifiedWindow({ windowName: PATIENT_CUSTOMER_INFORMATION }));

      deleteModifiedWindowSessionItem(SPOUSE_INFORMATION);
      dispatch(clearWindowError({ windowName: SPOUSE_INFORMATION }));
      dispatch(removeModifiedWindow({ windowName: SPOUSE_INFORMATION }));

      deleteModifiedWindowSessionItem(POE_INFORMATION);
      dispatch(clearWindowError({ windowName: POE_INFORMATION }));
      dispatch(removeModifiedWindow({ windowName: POE_INFORMATION }));

      deleteModifiedWindowSessionItem(COMMUNICATION_OPT_OUTS);
      dispatch(clearWindowError({ windowName: COMMUNICATION_OPT_OUTS }));
      dispatch(removeModifiedWindow({ windowName: COMMUNICATION_OPT_OUTS }));
    } else {
      deleteModifiedWindowSessionItem(label);
      dispatch(clearWindowError({ windowName: label }));
      dispatch(removeModifiedWindow({ windowName: label }));
    }

    const filteredWindows1 = chipData.filter(
      (chip) =>
        chip.code !== code &&
        chip.code !== '10' &&
        chip.code !== 'Account Status' &&
        chip.code != '0',
    );

    const availableTabs = filteredWindows.map((item) => item.code);

    setSelectedTabs(filteredWindows1 ? filteredWindows1 : null);
    setLabel([...availableTabs]);
    setChipData(filteredWindows);

    if (code === activeTabs[activeTabs?.length - 1]?.code) {
      setCurrentSelectedTab(activeTabs[value - 1]);
      setValue(value - 1);
      sessionStorage.setItem(
        'activeWindow',
        JSON.stringify({ index: value - 1, currentSelectedTab: activeTabs[value - 1] }),
      );
    } else {
      sessionStorage.setItem(
        'activeWindow',
        JSON.stringify({ index: value, currentSelectedTab: activeTabs[value + 1] }),
      );
      setCurrentSelectedTab(activeTabs[value + 1]);
    }

    handleFocusedWindowRemoval(code);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  /**
   * @type {[boolean, React.Dispatch<React.SetStateAction<boolean>>]}
   */
  const [popoverOpen, setPopoverOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setPopoverOpen(!popoverOpen);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setPopoverOpen(false);
  };

  const id = open ? 'chips-popover' : undefined;
  const chipsDivRef = useRef(null);
  useEffect(() => {
    // Access the DOM reference of the 'chips-div' element
    const chipsDiv = chipsDivRef.current;

    // Function to handle resizing and visibility calculation of chips
    const handleResize = () => {
      // show all chips to calculate the total width of each chip element
      setVisibleChips(selectedTabs.length);
      if (!chipsDiv) return;

      // Calculate the maximum width for chips before overflow (600px is the aprox back width of the buttons and the favorite icon)
      const maximumWidth = chipsDiv.offsetWidth - 600;
      let sumWidth = 0; // Total width of visible chips
      let totalChips = 0; // Total number of chips considered
      let stopIteration = false; // Flag to stop iteration once maximum width is reached

      // Iterate through selected tabs to calculate chip widths
      selectedTabs.forEach((each) => {
        if (!stopIteration) {
          totalChips++;
          // Get the chip element by its ID and calculate its width
          const chipElement = document.getElementById(`chip-${each.code}`);
          if (chipElement) {
            // Add the chip's width to the sumWidth
            sumWidth += chipElement.offsetWidth;
          }
          // Check if the sumWidth exceeds or equals the maximum allowed width
          if (sumWidth >= maximumWidth) {
            // Set the number of visible chips to one less than totalChips
            setVisibleChips(totalChips - 1);
            stopIteration = true;
          }
        }
      });
    };

    // Call handleResize initially
    handleResize();

    // Create a ResizeObserver to monitor changes in chipsDiv size
    const resizeObserver = new ResizeObserver(handleResize);
    if (chipsDiv) {
      resizeObserver.observe(chipsDiv);
    }

    // Clean up by disconnecting the ResizeObserver when component unmounts
    return () => {
      resizeObserver.disconnect();
    };
  }, [selectedTabs]);

  useEffect(() => {
    setCoordinates();
  }, [popoverOpen]);

  const iconRef = useRef(null);
  const [anchorPosition, setAnchorPosition] = useState(null);

  const setCoordinates = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setAnchorPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  };

  // Simple throttle function to limit execution of scroll events
  const throttle = (fn, wait) => {
    let isThrottled = false;

    return function (...args) {
      if (!isThrottled) {
        fn(...args);
        isThrottled = true;

        setTimeout(() => {
          isThrottled = false;
        }, wait);
      }
    };
  };

  // Sticky logic for
  const tabWrapperRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  // 112 is aligned with the header which also sticks
  const [offsetTop, setOffsetTop] = useState(0);
  const [leftOffset, setLeftOffset] = useState(0);

  useEffect(() => {
    const tabWrapper = tabWrapperRef.current;
    const chipsDiv = chipsDivRef.current;

    const handleScroll = throttle(() => {
      const scrollPosition = window.scrollY;
      // Check if we've scrolled past the initial position of the element
      if (scrollPosition > offsetTop) {
        setIsSticky(true); // Add sticky class when scrolling past
        if (chipsDiv) {
          const chipsDivRect = chipsDiv.getBoundingClientRect();
          setLeftOffset(chipsDivRect.left); // Set left offset to match #chips-div
        }
      } else {
        setIsSticky(false); // Remove sticky class when scrolling back
      }
    }, 80);

    // Store the element's initial offset from the top
    if (tabWrapper) {
      setOffsetTop(tabWrapper.offsetTop);
    }

    // Add the scroll event listener
    window.addEventListener('scroll', handleScroll);

    return () => {
      // Cleanup the scroll event listener on unmount
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop]);

  return (
    <Box id="chips-div" ref={chipsDivRef}>
      <div
        ref={tabWrapperRef}
        style={{
          left: isSticky ? `${leftOffset}px` : 'auto',
        }}
        className={`${
          SPLIT_SCREEN.ARRAY_VALUES.includes(showDashboardWorkQueue) &&
          location.pathname === `/account-summary` &&
          calculateAge(accountSummaryData.birthDate) < age18 &&
          hideSummary
            ? `tab-workqueqerpfirstname ${isSticky ? 'sticky-tab-wrapper' : ''}`
            : SPLIT_SCREEN.ARRAY_VALUES.includes(showDashboardWorkQueue) &&
              location.pathname === `/account-summary` &&
              calculateAge(accountSummaryData.birthDate) < age18 &&
              !hideSummary
              ? 'sticky-rp-workqueue'
              : SPLIT_SCREEN.ARRAY_VALUES.includes(showDashboardWorkQueue) &&
              location.pathname === `/account-summary` &&
              !age &&
              hideSummary
                ? `tab-workqueqetabwraper ${isSticky ? 'sticky-tab-wrapper' : ''}`
                : SPLIT_SCREEN.ARRAY_VALUES.includes(showDashboardWorkQueue) &&
              location.pathname === `/account-summary`
                  ? `tab-workqueqeblock ${isSticky ? 'sticky-tab-wrapper' : ''}`
                  : !age && hideSummary
                    ? `account-tab-wrapper ${isSticky ? 'sticky-tab-wrapper' : ''}`
                    : hideSummary && age
                      ? 'rp-tab-wrapper'
                      : calculateAge(accountSummaryData.birthDate) < age18
                        ? 'sticky-rp-tab-wrapper'
                        : `tab-wrapper  ${isSticky ? 'sticky-tab-wrapper' : ''}`
        }`}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            backgroundColor: globalColors.white,
            padding: '10px',
            height: '50px',
          }}
        >
          <CustomChipWrapper
            direction="row"
            spacing={2}
            value={value}
            onChange={(e) => handleChange(e)}
            aria-label="default windows"
            variant="scrollable"
            scrollButtons="auto"
            className="chip-wrapper"
            sx={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'flexStart',
              margin: '0',
              padding: '0',
              backgroundColor: globalColors.white,
            }}
          >
            {defaultWindows?.map((each, index) => {
              return (
                <Chip
                  sx={{
                    marginLeft: index === 0 ? '0 !important' : '14px !important',
                    fontWeight: 700,
                  }}
                  id={`chip-${each.code}`}
                  key={each.code}
                  onClick={() => handleTabSelect(each, index)}
                  label={each.label}
                  color={
                    updatedForms.some((form) => form === each.code)
                      ? 'success'
                      : focusedWindows.some((window) => window.code === each.code)
                        ? 'focused'
                        : 'primary'
                  }
                  icon={
                    <BookmarkIcon
                      style={{
                        color: globalColors.palette.info.dark,
                        height: '20px',
                      }}
                    />
                  }
                />
              );
            })}

            {visibleChips > 0 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  margin: '0 12px !important',
                  backgroundColor: globalColors.dividerColor,
                }}
              />
            )}

            {selectedTabs?.slice(0, visibleChips).map((each, index) => {
              return (
                <Chip
                  sx={{
                    fontWeight: 700,
                    marginLeft: index === 0 ? '0 !important' : '14px !important',
                  }}
                  id={`chip-${each.code}`}
                  key={each.code}
                  onClick={() => handleTabSelect(each, index)}
                  onDelete={() => handleRemove(each, index)}
                  label={each.label}
                  color={
                    updatedForms.some((form) => form === each.code)
                      ? 'success'
                      : focusedWindows.some((window) => window.code === each.code)
                        ? 'focused'
                        : 'default'
                  }
                />
              );
            })}
          </CustomChipWrapper>
          {selectedTabs?.length > visibleChips && (
            <>
              <IconButton
                aria-describedby={id}
                onClick={handleClick}
                size="small"
                sx={{
                  marginLeft: 'auto',
                  marginRight: '0',
                  height: '32px',
                  width: '32px',
                  borderRadius: '16px',
                  color: globalColors.black,
                  '&:hover': {
                    backgroundColor: hexToRGBA(globalColors.palette.info.light, '.30'),
                    color: globalColors.palette.info.main,
                  },
                  '&:hover .double-arrow-icon path': {
                    fill: globalColors.palette.info.main,
                  },
                }}
              >
                <DoubleArrowRightIcon
                  ref={iconRef}
                  id="double-arrow-icon"
                  style={{
                    height: '13px',
                    width: '13px',
                    marginRight: '-3px',
                  }}
                  className="double-arrow-icon"
                />
              </IconButton>
              {/* Popover with Overflowing Chips */}
              <Popover
                id={id}
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                  anchorPosition
                    ? { top: anchorPosition.top, left: anchorPosition.left }
                    : undefined
                }
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <Stack
                  direction="column"
                  spacing={1}
                  sx={{
                    p: 2,
                    width: 'auto',
                  }}
                >
                  {selectedTabs?.slice(visibleChips).map(
                    (
                      each,
                      index, // Start slicing from where the previous left off
                    ) => (
                      <Chip
                        sx={{
                          fontWeight: 700,
                          width: 'auto',
                          justifyContent: 'space-between',
                          marginLeft: index === 0 ? '0 !important' : '14px !important',
                        }}
                        id={`chip-${each.code}`}
                        key={each.code}
                        onClick={() => handleTabSelect(each, index)}
                        onDelete={() => handleRemove(each, index)}
                        label={each.label}
                        color={
                          updatedForms.some((form) => form === each.code)
                            ? 'success'
                            : focusedWindows.some((window) => window.code === each.code)
                              ? 'focused'
                              : 'default'
                        }
                      />
                    ),
                  )}
                </Stack>
              </Popover>
            </>
          )}
          <FavoriteWindowToggler></FavoriteWindowToggler>
        </Box>

        <Typography />
      </div>
      <FocusedWindows
        tempReRenderWindow={tempReRenderWindow}
        setTempReRenderWindow={setTempReRenderWindow}
      />
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </Box>
  );
}
